import { SelectItem } from '@openng/optimus-ui/api';
import { Column } from '../../model/common/column';

export function getCommercialFacilityTableColumns(
  availableCompanies: SelectItem[],
  availableFacilityTypes: SelectItem[],
  availableAORs: SelectItem[],
  availableOperatingAreas: SelectItem[],
  availableMarketAreas: SelectItem[],
  trueFalseOptions: SelectItem[],
  isMobile: boolean
): Column[] {
  if (isMobile) {
    return [
      {
        field: 'facilityName',
        header: 'COMMERCIAL_SERVICES.LABEL.FACILITY_NAME',
        mobileHeader: 'COMMERCIAL_SERVICES.LABEL.FACILITY_NAME',
        hideMobileLabel: true,
        formatPattern: 'hyperlink',
        width: '55%',
        sortable: true,
        filterable: true,
        matchMode: 'contains',
      },
      {
        field: 'facilityId',
        header: 'COMMERCIAL_SERVICES.LABEL.FACILITY_ID',
        mobileHeader: 'COMMERCIAL_SERVICES.LABEL.FACILITY_ID',
        hideMobileLabel: true,
        formatPattern: 'text',
        width: '45%',
        sortable: true,
        filterable: true,
        matchMode: 'contains',
      },
    ];
  }

  return [
    {
      field: 'facilityName',
      header: 'COMMERCIAL_SERVICES.LABEL.FACILITY_NAME',
      formatPattern: 'text',
      width: '14%',
      sortable: true,
      filterable: true,
      matchMode: 'contains',
    },
    {
      field: 'facilityId',
      header: 'COMMERCIAL_SERVICES.LABEL.FACILITY_ID',
      formatPattern: 'text',
      width: '10%',
      sortable: true,
      filterable: true,
      matchMode: 'contains',
    },
    {
      field: 'company',
      header: 'COMMERCIAL_SERVICES.LABEL.COMPANY',
      formatPattern: 'text',
      type: 'dropdown',
      width: '10%',
      sortable: true,
      filterable: true,
      options: availableCompanies,
      matchMode: 'equals',
    },
    {
      field: 'facilityType',
      header: 'COMMERCIAL_SERVICES.LABEL.FACILITY_TYPE',
      formatPattern: 'text',
      type: 'dropdown',
      width: '10%',
      sortable: true,
      filterable: true,
      options: availableFacilityTypes,
      matchMode: 'equals',
    },
    {
      field: 'aor',
      header: 'LOCATION.LABEL.AOR',
      formatPattern: 'text',
      type: 'dropdown',
      width: '9%',
      sortable: true,
      filterable: true,
      options: availableAORs,
      matchMode: 'equals',
    },
    {
      field: 'operatingArea',
      header: 'COMMERCIAL_SERVICES.LABEL.OPERATING_AREA',
      formatPattern: 'text',
      type: 'dropdown',
      width: '11%',
      sortable: true,
      filterable: true,
      options: availableOperatingAreas,
      matchMode: 'equals',
    },
    {
      field: 'marketArea',
      header: 'COMMERCIAL_SERVICES.LABEL.MARKET_AREA',
      formatPattern: 'text',
      type: 'dropdown',
      width: '11%',
      sortable: true,
      filterable: true,
      options: availableMarketAreas,
      matchMode: 'equals',
    },
    {
      field: 'facilityLineSegment',
      header: 'COMMERCIAL_SERVICES.LABEL.LINE_SEGMENT',
      formatPattern: 'text',
      width: '11%',
      sortable: true,
      filterable: true,
      matchMode: 'contains',
    },
    {
      field: 'rateableTake',
      header: 'COMMERCIAL_SERVICES.LABEL.RATEABLE_TAKE',
      formatPattern: 'text',
      type: 'dropdown',
      width: '7%',
      sortable: true,
      filterable: true,
      options: trueFalseOptions,
      matchMode: 'equals',
    },
    {
      field: 'criticalDay',
      header: 'COMMERCIAL_SERVICES.LABEL.CRITICAL_DAY',
      formatPattern: 'text',
      type: 'dropdown',
      width: '7%',
      sortable: true,
      filterable: true,
      options: trueFalseOptions,
      matchMode: 'equals',
    },
  ];
}
